import axios from "axios";
import router from "../router";
import {openSubscribePage} from "./NavigationUtils";

// TODO: Start to create a new back end service
export class BackEndService {
  private static postConfig = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  };

  public static redirectToBackEndUrl(path: string, isPlayApi: boolean = false) {
    window.location.href = process.env.API_URL! + (isPlayApi ? process.env.API_VERSION! : '') + path;
  }

  public static sendPostRequest(route: string, data: any = null) {
    return axios.post(process.env.API_URL! + process.env.API_VERSION! + route, data, this.postConfig)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        else {
          console.error('Back end return an error ' + response.status + 'for ' + route);
        }
      })
      .catch(function (error) {
        if (!BackEndService.redirectToOfflinePageDependingOnConnexionStatus() && !BackEndService.redirectToLoginPageIfNeeded(error)) {
          console.error('Error in POST Request : ' + route);
          console.error(error);
        }
        return Promise.reject(error.response);
      });
  }

  public static sendPostFileRequest(route: string, file: File, additionalData: any = null) {
    const formData = new FormData();
    formData.append('file', file);
    if (additionalData) {
      Object.entries(additionalData).forEach(([key, value]) => {
        formData.append(key, value as any);
      });
    }

    const postFileConfig = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    };

    return axios.post(process.env.API_URL! + process.env.API_VERSION! + route, formData, postFileConfig)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        else {
          console.error('Back end return an error ' + response.status + 'for ' + route);
        }
      })
      .catch(function (error) {
        if (!BackEndService.redirectToOfflinePageDependingOnConnexionStatus() && !BackEndService.redirectToLoginPageIfNeeded(error)) {
          console.error('Error in POST File Request : ' + route);
          console.error(error);
        }
        return Promise.reject(error.response);
      });
  }

  public static sendDeleteRequest(route: string) {
    return axios.delete(process.env.API_URL! + process.env.API_VERSION! + route, this.postConfig)
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        else {
          console.error('Back end return an error ' + response.status + 'for ' + route);
        }
      })
      .catch(function (error) {
        if (!BackEndService.redirectToOfflinePageDependingOnConnexionStatus() && !BackEndService.redirectToLoginPageIfNeeded(error)) {
          console.error('Error in DELETE Request : ' + route);
          console.error(error);
        }
        return Promise.reject(error.response);
      });
  }

  private static getConfig = {
    headers: {
      'Accept': 'application/json',
    },
  };
  public static sendGetRequest(route: string, parameters: any[] = [], apiVersion: number = 1) {
    const apiVersionString = `play-api/v${apiVersion}/`
    const getParameters = BackEndService.parametersToGetRequest(parameters);
    return axios.get(process.env.API_URL! + apiVersionString + route + getParameters, this.getConfig)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          return response.data;
        }
        else {
          console.error('Back end return an error ' + response.status + 'for ' + route);
        }
      })
      .catch(function (error) {
        if (!BackEndService.redirectToOfflinePageDependingOnConnexionStatus() && !BackEndService.redirectToLoginPageIfNeeded(error) && !BackEndService.redirectToSubscribePageIfNeeded(error)) {
          console.error('Error in GET Request : ' + route);
          console.error(error);
          return BackEndService.redirectToMaintenancePageDependingOnStatus(error.response.status);
        }
        return Promise.reject(error.response);
      });
  }

  public static parametersToGetRequest(parameters: any) {
    if (typeof parameters !== 'object') {
      return ''
    }

    const entries = Object.entries(parameters);
    if (entries.length === 0) {
      return '';
    }

    const getParameters = entries.map(([key, value]) =>
      // @ts-ignore
      `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    ).join('&');

    return `?${getParameters}`;
  }


  public static readonly MAINTENANCE_STATUS_CODE = [503, 404, 502];
  public static redirectToMaintenancePageIfServerIsDown(): Promise<boolean> {
    return axios.get(process.env.API_URL! + process.env.API_VERSION! + 'status', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      return BackEndService.redirectToMaintenancePageDependingOnStatus(response?.status || 200);
    }).catch(function () {
      BackEndService.pushMaintenancePage();
      return true;
    });
  }
  private static redirectToMaintenancePageDependingOnStatus(responseStatus: number) {
    if (BackEndService.MAINTENANCE_STATUS_CODE.includes(responseStatus)) {
      BackEndService.pushMaintenancePage();
      return true;
    }
    return false;
  }
  private static pushMaintenancePage() {
    if (router.currentRoute.name !== 'Maintenance') {
      router.replace('/maintenance').then();
    }
  }

  public static redirectToOfflinePageDependingOnConnexionStatus() {
    if (!window.navigator.onLine) {
      BackEndService.pushOfflinePage()
      return true;
    }
    return false;
  }
  private static pushOfflinePage() {
    if (router.currentRoute.name !== 'Offline') {
      router.replace('/offline').then();
    }
  }

  // When receiving UNAUTHORIZED_STATUS_CODE it means that there is a login issue so we redirect to this page
  // In case the resource is not accessible by the user we need to return FORBIDDEN_STATUS_CODE
  public static readonly UNAUTHORIZED_STATUS_CODE = 401;
  public static readonly FORBIDDEN_STATUS_CODE = 403;
  private static redirectToLoginPageIfNeeded(error: any) {
    if (error.response.status === BackEndService.UNAUTHORIZED_STATUS_CODE) {
      BackEndService.pushLoginPage();
      return true;
    }
    return false;
  }
  private static pushLoginPage() {
    delete localStorage.tokenTokatab;
    if (router.currentRoute.name !== 'Login') {
      router.replace('/login').then();
    }
  }

  private static redirectToSubscribePageIfNeeded(error: any) {
    if (error.response.status === 402) {
      BackEndService.pushSubscribePage();
      return true;
    }
    return false;
  }

  private static pushSubscribePage() {
    if (router.currentRoute.name !== 'Subscribe Page') {
      openSubscribePage(router.currentRoute.path, undefined, '/home');
    }
  }
}
